if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        /**
         * @type {Array<HTMLInputElement> | null}
         */
        this.propertyInputs = Array.from(
          this.querySelectorAll('[name^="properties"]')
        );
        this.properties = this.parseProperties(this.propertyInputs);
        const productInfoElement = this.querySelector("#product-info");
        // console.log("productInfoElement: ", productInfoElement);
        if (productInfoElement) {
          this.productInfo = JSON.parse(
            productInfoElement && productInfoElement?.textContent
              ? productInfoElement.textContent
              : ""
          );
        }
        // console.log('productInfo: ', this.productInfo);

        /**
         * @type {number | null}
         * */
        this.brandLimit = knocking.getBrandLimit(this.productInfo.vendor);
        // console.log('brandLimit: ', this.brandLimit);

        /**
         * @type {number | null}
         * */
        this.productLimit = knocking.getProductLimit(this.productInfo.id);
        if (
          !this.productLimit &&
          !this.brandLimit &&
          window.enableGlobalProductLimit
        ) {
          this.productLimit = window.globalProductLimit;
        }

        this.referals = this.getReferals();
        this.mergeVoucherCodeVariants =
          this.dataset.mergeVoucherCodeVariants === "true";
        // console.log(
        //   "mergeVoucherCodeVariants: ",
        //   this.mergeVoucherCodeVariants
        // );
        // this.promoCode = this.getPromoCode();
        // this.preLimit = this.getPreLimit();
      }

      connectedCallback() {
        // console.log("Product-form connected");

        /**
         * @type {HTMLFormElement | null}
         */
        this.form = this.querySelector("form");
        if (!this.form) {
          console.error("Cannot find product-form, aborting...");
          return;
        }
        const formData = new FormData(this.form);
        this.formDataEntries = Object.fromEntries(formData.entries());

        /**
         * @type {HTMLButtonElement | null}
         */
        const addToCartButton = this.form.querySelector(
          'button[type="submit"]'
        );
        if (addToCartButton) {
          this.addtoCartButtonLocation = addToCartButton.dataset.buttonLocation;
        }

        this.formId = this.form.getAttribute("id");

        // reset form on message
        messenger.listen(messenger.topics.RESET_PRODUCT_FORM, () => {
          return;
          // console.log("resetting form: ", this.form);
          if (!this.form) {
            console.error("Cannot find form to reset...");
            return;
          }
          this.form.reset();
        });

        // prevent form submit on enter
        this.form.addEventListener("keypress", (event) => {
          if (event.key === "Enter") {
            event.preventDefault();
          }
        });
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        // this.cartNotification = document.querySelector('cart-notification');

        /**
         * @type {HTMLElement | null}
         */
        this.addToCartAlert = this.querySelector(".add_to_cart_alert");

        this.shipsByValue = this.getShipsByValue();
        // legacy code, ships by should be set up by variant-select for PP and product-card for the card exclusively
        // if (this.productInfo.hasOnlyOneVariant && this.shipsByValue) {
        //   this.setShipsBy(this.shipsByValue);
        // }

        this.isVoucherProduct =
          this.productInfo.tags.includes("Voucher") ||
          this.productInfo.tags.includes("voucher") ||
          this.productInfo.tags.includes("voucher-code");

        /**
         * @type {HTMLElement | null}
         */
        this.addToCartAlertFailed = this.querySelector(
          ".add_to_cart_alert_failed"
        );
        if (this.addToCartAlertFailed) {
          const closeX = this.addToCartAlertFailed.querySelector("button");
          closeX?.addEventListener("click", () => {
            if (!this.addToCartAlertFailed) return;
            this.addToCartAlertFailed.style.display = "none";
          });
        }

        if (
          this.formIsRenderedOnFeaturedProductSection() ||
          this.formIsRenderedOnMultiColumnBoxSection()
        ) {
          this.setShipsBy(this.shipsByValue);
        }

        let formIsMain = false;
        if (this.formId) {
          formIsMain = this.formId.includes("main");
        }
        if (formIsMain) {
          // console.log('product-form is being rendered on a product page');
          window.postMessage(
            {
              type: "product_form_ready",
            },
            "*"
          );

          /**
           * @type {HTMLElement | null}
           */
          this.orderLimitNoticeBrand = document.querySelector(
            "#brand-order-limit-notice"
          );
          /** @type {HTMLElement | null}
           */
          this.orderLimitNoticeProduct = document.querySelector(
            "#product-order-limit-notice"
          );

          if (this.productLimit) {
            // console.log('showing product limit notice');
            this.showProductLimitNotice(
              this.productInfo.name,
              this.productLimit
            );
          } else if (this.brandLimit) {
            // console.log('showing brand limit notice');
            this.showBrandLimitNotice(this.productInfo.vendor, this.brandLimit);
          }
        }
      }

      formIsRenderedOnFeaturedProductSection() {
        const parentSection = this.closest("section");

        if (!parentSection) return false;

        const classList = Array.from(parentSection.classList);

        for (const className of classList) {
          if (className.includes("featured_product")) {
            return true;
          }
        }
        return false;
      }

      formIsRenderedOnMultiColumnBoxSection() {
        const parentSection = this.closest("section");

        if (!parentSection) return false;

        const classList = Array.from(parentSection.classList);

        for (const className of classList) {
          if (className.includes("multicolumn-cbs-deals-box")) {
            return true;
          }
        }
        return false;
      }

      formIsRenderedOnProductPage() {
        const parentSection = this.closest("section");

        if (!parentSection) return false;

        const classList = Array.from(parentSection.classList);

        for (const className of classList) {
          if (className.includes("main")) {
            return true;
          }
        }
        return false;
      }

      getShipsByValue() {
        const shipsBy = knocking.getTagShippingDate(this.productInfo.tags);
        return shipsBy;
      }

      // marked for removal
      getProductTags() {
        const productCard = this.closest("product-card");
        const swiperVariantMobile = this.closest("swiper-variants-mobile");

        if (productCard) {
          // console.log('product-form is beeing rendered on a product-card');
          const element = productCard.querySelector(".product-card-product");
          if (!element) {
            console.error("Cannot get product-element!");
            return;
          }
          const tags = JSON.parse(element.textContent || "").tags;
          return tags;
        } else if (swiperVariantMobile) {
          const element = this.querySelector(
            'script[data-id="product-data-tags"]'
          );
          if (!element) {
            console.error("Cannot get tag-element!");
            return;
          }
          const tags = JSON.parse(element.textContent || "");
          return tags;
        } else {
          // console.log('product-form is beeing rendered on a product page');
          const element = document.querySelector(
            'script[data-id="product-data-tags"]'
          );
          if (!element) {
            console.error("Cannot get tag-element!");
            return;
          }
          const tags = JSON.parse(element.textContent || "");

          if (tags) return tags;

          return null;
        }
      }

      getReferals() {
        const storageEntries = Object.entries(sessionStorage);
        const renamingProps = Object.entries(window.referalRenaming);
        let referals = {};

        for (const [key, value] of storageEntries) {
          if (key.includes("referals-")) {
            let referalKey = key.replace("referals-", "");
            let propName = referalKey;

            for (const [oldString, NewString] of renamingProps) {
              if (oldString == referalKey) {
                propName = NewString;
                break;
              }
            }
            referals[propName] = value;
          }
        }
        return referals;
      }

      getPromoCode() {
        return knocking.getCookie("promo_code");
      }

      resetAddToCartAlert() {
        if (!this.addToCartAlert) return;
        this.addToCartAlert.style.display = "none";
        if (!this.addToCartAlertFailed) return;
        this.addToCartAlertFailed.style.display = "none";
      }

      /**
       * @param {ShipsByStrings} shipsByValue
       * */
      setShipsBy(shipsByValue) {
        /** @type {HTMLInputElement | null} */
        const shipsByInput = this.querySelector("input[id='ships-by-input']");

        // console.log(
        //   `setting ships by: ${shipsByValue} for product ${this.productInfo.name}`
        // );

        if (!shipsByInput) {
          console.error("Cannot find ships-by-input");
          return;
        }
        if (!shipsByValue) {
          console.error("Cannot find shipsByValue");
          return;
        }
        shipsByInput.value = shipsByValue.longDate;
      }

      /**
       * @param {string} vendor
       * @param {number} limit
       */
      showBrandLimitNotice(vendor, limit) {
        if (this.orderLimitNoticeBrand) {
          this.orderLimitNoticeBrand.innerHTML =
            this.orderLimitNoticeBrand.innerHTML
              .replace("[limit]", limit.toString())
              .replace("[brand]", decodeURIComponent(vendor));
          this.orderLimitNoticeBrand.style.display = "block";
        }
      }

      showProductLimitNotice(product, limit) {
        if (this.orderLimitNoticeProduct) {
          this.orderLimitNoticeProduct.innerHTML =
            this.orderLimitNoticeProduct.innerHTML.replace("[limit]", limit);
          this.orderLimitNoticeProduct.style.display = "block";
        }
      }

      /**
       * @param {Array<HTMLInputElement>} inputs
       */
      parseProperties(inputs) {
        if (inputs.length === 0) {
          return;
        }
        /**
         * @type {Record<string, string>}
         */
        let properties = {};
        for (let i = 0; i < inputs.length; i++) {
          const input = inputs[i];
          let key = input.name.replace("properties[", "").replace("]", "");
          let value = input.value;
          properties[key] = value;
        }
        return properties;
      }

      getQuantityValue() {
        if (this.closest("product-card")) {
          return 1;
        }
        /**
         * @type {HTMLInputElement | null}
         */
        const quantitySelector = document.querySelector(
          '.quantity__input[id^="Quantity-template"]'
        );
        if (!quantitySelector) {
          return 1;
        }
        return parseInt(quantitySelector.value);
      }

      /**
       * @param {string} error
       */
      responseErrorHandler(error) {
        if (error) {
          return "The selected quantity exceeds the number of units currently available for this product";
        }
        return "Something went wrong";
      }

      resetProductForm() {
        return;
        // console.log("resetting form: ", this.form);
        if (!this.form) {
          console.error("Cannot find form to reset...");
          return;
        }
      }

      /**
       * @param {string} error
       * @returns {void}
       * */
      showAddToCartAlert(error) {
        messenger.emmit(messenger.topics.SET_THIS_CARD_BUTTON_TO_SOLD_OUT, {
          productId: this.productInfo.id,
        });

        if (this.addToCartAlert) {
          const messageOutput = this.addToCartAlert.querySelector("span");
          if (messageOutput && error) {
            messageOutput.textContent = this.responseErrorHandler(error);
            this.addToCartAlert.style.display = "block";
          }
        } else {
          console.log("Cannot find add-to-cart-alert");
        }
      }

      /**
       * @param {SubmitEvent} evt
       */
      async onSubmitHandler(evt) {
        evt.preventDefault();
        // console.log("onSubmitHandler submitter: ", evt.submitter);
        // console.log("submitting form: ", this.formDataEntries);
        this.resetAddToCartAlert();

        const submitButton =
          evt.submitter || this.querySelector('[type="submit"]');

        if (!submitButton) {
          console.error("Cannot find submit-button!");
          return;
        }
        submitButton.setAttribute("disabled", "true");
        submitButton.classList.add("loading");

        const forms = Array.from(this.querySelectorAll("form"));

        let items = [];

        let singleVariantQuantity;
        let totalProductQuantity = 0;

        for (let i = 0; i < forms.length; i++) {
          const uuid = knocking.getUniqueId();
          const form = forms[i];
          const formType = form.dataset.type;
          if (formType !== "add-to-cart-form") {
            continue;
          }
          let formData = JSON.parse(knocking.serializeForm(form));

          if (!formData.quantity) {
            formData.quantity = this.getQuantityValue();
          }

          totalProductQuantity = singleVariantQuantity
            ? totalProductQuantity + singleVariantQuantity
            : totalProductQuantity + formData.quantity;

          /**
           * @type {Record<string, string>}
           */
          let properties = {};

          /**
           * @type {Array<string>}
           */
          let voucherCodes = [];

          if (this.isVoucherProduct) {
            const variantAlreadyInCart = await store.checkIfVariantIsInCart(
              formData.id
            );

            /** @type {HTMLInputElement | null} */
            const vendorElement = this.querySelector('input[name="vendor"]');
            /** @type {HTMLInputElement | null} */
            const skuElement = this.querySelector('input[name="sku"]');

            if (!vendorElement || !skuElement) {
              console.error("Cannot find vendor or sku for voucher product");
              return;
            }
            const vendor = vendorElement.value;
            const sku = skuElement.value;
            // console.log("Vendor value: ", vendor);

            const voucherCodeRes = await knocking.getVoucherCode(
              vendor,
              sku,
              formData.quantity
            );
            if (!voucherCodeRes) {
              console.log("voucherCodeRes is null, returning...");

              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");

              return;
            }
            voucherCodes = voucherCodeRes;

            /** If a variant with voucher is already in cart, we only update the quantity. The update cart function will handle updating the voucher codes */
            // console.log("variantAlreadyInCart:", variantAlreadyInCart);
            // console.log(
            //   "mergeVoucherCodeVariants:",
            //   this.mergeVoucherCodeVariants
            // );
            if (variantAlreadyInCart && this.mergeVoucherCodeVariants) {
              // console.log("merging vouchercode items");
              const lineNumber = await store.getLineNumberOfItem(
                variantAlreadyInCart.id
              );
              if (!lineNumber) {
                console.error("Cannot find line number of item in cart");
                return;
              }

              const existingQty =
                typeof variantAlreadyInCart.quantity === "string"
                  ? parseInt(variantAlreadyInCart.quantity)
                  : variantAlreadyInCart.quantity;
              const additionalQty =
                typeof formData.quantity === "string"
                  ? parseInt(formData.quantity)
                  : formData.quantity;
              const newQuantity = existingQty + additionalQty;

              const updateQuantityRes = await store.updateCartQuantity(
                lineNumber,
                newQuantity
              );
              // console.log("updateQuantityRes: ", updateQuantityRes);

              knocking.buildCart(updateQuantityRes);

              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");

              knocking.openCart();

              return;
            } else {
              // console.log("adding voucher code");
              properties["_encoded-vouchers"] = voucherCodes;
            }
          }

          const promoCode = this.getPromoCode();

          if (promoCode) {
            properties["_promo-code"] = promoCode;
          }

          for (const [key, value] of Object.entries(this.referals)) {
            properties[`_${key}`] = value;
          }

          for (const [key, value] of Object.entries(formData)) {
            if (key.includes("properties")) {
              let propKey = key.replace("properties[", "").replace("]", "");
              let propValue = value;
              properties[propKey] = propValue;
            }
          }

          delete formData.limit;

          formData.properties = properties;

          // Check for custom sku
          const customSku = document.querySelector("custom-sku-nfl");
          // console.log("customSku: ", customSku);
          // NOTE: Custom sku form date is not set properly when triggered through the holiday modal...compare "add_to_cart" key!
          if (customSku) {
            const customSkuForm = customSku.querySelector("form");
            const customSkuFormData = JSON.parse(
              knocking.serializeForm(customSkuForm)
            );
            console.log("customSkuFormData: ", customSkuFormData);

            if (customSkuFormData["add-to-cart"] !== "false") {
              let properties = {};

              for (const [key, value] of Object.entries(customSkuFormData)) {
                if (key.includes("properties")) {
                  let propKey = key.replace("properties[", "").replace("]", "");
                  let propValue = value;
                  properties[propKey] = propValue;
                }
              }
              customSkuFormData.properties = properties;

              items.push(customSkuFormData);
            }
          }

          if (
            formData.properties["_encoded-vouchers"] &&
            !this.mergeVoucherCodeVariants
          ) {
            const vouchers = /** @type {string[]} */ (
              formData.properties["_encoded-vouchers"]
            );
            vouchers.forEach((voucher) => {
              items.push(
                Object.assign({}, formData, {
                  properties: Object.assign({}, formData.properties, {
                    "_encoded-vouchers": [voucher],
                    _hideQtySelector: true,
                  }),
                  quantity: 1,
                })
              );
            });
          } else {
            items.push(formData);
          }
        }

        // console.log("items: ", items);

        const payload = JSON.stringify({ items });
        // console.log("items: ", items);

        // console.log("product limit: ", this.productLimit);

        // order limits
        if (this.productLimit) {
          let qty;

          // console.log('quantity: ', JSON.parse(serializeForm(this.form)));
          qty = JSON.parse(serializeForm(this.form)).quantity || 1;

          const productLimitReached =
            await knocking.checkIfProductLimitIsReached(
              this.productInfo.id,
              this.productLimit,
              qty
            );
          // console.log("productLimitReached: ", productLimitReached);
          if (productLimitReached.hasLimit) {
            knocking.alertProductLimitReached(
              this.productInfo.name,
              this.productLimit
            );
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            console.log("product limit reached");
            return;
          }
        }
        if (this.brandLimit && !this.productLimit) {
          let qty;

          qty = JSON.parse(serializeForm(this.form)).quantity || 1;
          const brandLimitReached = await knocking.checkIfBrandLimitIsReached(
            this.productInfo.vendor,
            this.brandLimit,
            qty
          );
          if (brandLimitReached.hasLimit) {
            // knocking.alertBrandLimitReached(
            //   this.productInfo.vendor,
            //   this.brandLimit
            // );
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            console.log("brand limit reached");
            return;
          }
        }
        // order limits end

        // Klaviyo
        let _learnq = window._learnq || [];

        let res;
        try {
          res = await store.addToCart(payload);
          console.log("res in add to cart: ", res);

          if (_learnq && res) {
            const klaviyoCart = {
              total_price: res.total_price / 100,
              $value: res.total_price / 100,
              total_discount: res.total_discount,
              original_total_price: res.original_total_price / 100,
              items: res.items,
            };
            // console.log("Klaviyo cart: ", klaviyoCart);
            _learnq.push(["track", "Added to Cart", klaviyoCart]);
          } else {
            console.log(
              'Klaviyo not loaded, couldn\'t track "Added to Cart" event'
            );
          }
          messenger.emmit(messenger.topics.RESET_PRODUCT_FORM);
          // this.resetProductForm();
        } catch (/** @type {any} */ error) {
          console.log("error on add to cart: ", error);
          this.showAddToCartAlert(error);
        }

        submitButton.classList.remove("loading");
        submitButton.removeAttribute("disabled");
      }
    }
  );
}
